import { defineMessages } from 'react-intl';

export const addReviewFormMessages = defineMessages({
  titleLabel: {
    defaultMessage: 'Überschrift',
    id: 'customerReviews.addReview.addReviewForm.title.label',
  },
  titlePlaceholder: {
    defaultMessage: 'Klasse Produkt!',
    id: 'customerReviews.addReview.addReviewForm.title.placeholder',
  },
  descriptionLabel: {
    defaultMessage: 'Ausführliche Bewertung*',
    id: 'customerReviews.addReview.addReviewForm.description.label',
  },
  descriptionPlaceholder: {
    defaultMessage: 'Erzähle uns etwas über das Produkt.',
    id: 'customerReviews.addReview.addReviewForm.description.placeholder',
  },
  descriptionError: {
    defaultMessage: 'Du musst eine Bewertung eingeben.',
    id: 'customerReviews.addReview.addReviewForm.description.error',
  },
  descriptionErrorTooShort: {
    defaultMessage: 'Bewertung ist zu kurz',
    id: 'customerReviews.addReview.addReviewForm.description.error.tooShort',
  },
  descriptionErrorTooLong: {
    defaultMessage: 'Bewertung ist zu lang',
    id: 'customerReviews.addReview.addReviewForm.description.error.tooLong',
  },
  nameLabel: {
    defaultMessage: 'Name',
    id: 'customerReviews.addReview.addReviewForm.name.label',
  },
  namePlaceholder: {
    defaultMessage: 'Dein (Spitz-)Name',
    id: 'customerReviews.addReview.addReviewForm.name.placeholder',
  },
  nameError: {
    defaultMessage: 'Du musst einen Nicknamen eingeben.',
    id: 'customerReviews.addReview.addReviewForm.name.error',
  },
  nameErrorTooShort: {
    defaultMessage: 'Name ist zu kurz',
    id: 'customerReviews.addReview.addReviewForm.name.error.tooShort',
  },
  nameErrorTooLong: {
    defaultMessage: 'Name ist zu lang',
    id: 'customerReviews.addReview.addReviewForm.name.error.tooLong',
  },
  mandatoryHint: {
    defaultMessage: 'Die mit * markierten Felder sind Pflichtfelder.',
    id: 'customerReviews.addReview.addReviewForm.mandatoryHint',
  },
  recommendedLabel: {
    defaultMessage: 'Würden Sie diesen Artikel weiterempfehlen?',
    id: 'customerReviews.addReview.addReviewForm.recommended.label',
  },
  recommendedYes: {
    defaultMessage: 'Ja',
    id: 'customerReviews.addReview.addReviewForm.recommended.yes',
  },
  recommendedNo: {
    defaultMessage: 'Nein',
    id: 'customerReviews.addReview.addReviewForm.recommended.no',
  },
});
